import React from 'react';
import { withLoadingAndNoConnectionHandler } from '../../../integration-wrapper';
import { Contract } from '@cp-mx/common';
import { InsuranceDetailsUi } from './ui/InsuranceDetailsUi';
import { useVehicleDetails } from '../vehicle-details/useVehicleDetails';

const InsuranceDetailsWithHandlers = withLoadingAndNoConnectionHandler(InsuranceDetailsUi);

export const InsuranceDetails: React.FC<{ contract: Contract; title?: string }> = ({ contract, title }) => {
    const { data: vehicleDetails, isLoading, loadingError } = useVehicleDetails(contract.contractNumber);
    return (
        <InsuranceDetailsWithHandlers
            isLoading={isLoading}
            vehicleDetails={vehicleDetails}
            title={title}
            contract={contract}
            hasError={!!loadingError}
            component="insurance-details"
        />
    );
};
